import { Group, Pagination, Text } from "@mantine/core";
import { useTranslation } from "../../../hooks/useTranslation";

interface EmployeeOverviewPaginationProps {
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    totalItems: number;
    onPageChange: (page: number) => void;
}

export function EmployeeOverviewPagination({
    totalPages,
    pageIndex,
    pageSize,
    totalItems,
    onPageChange,
}: EmployeeOverviewPaginationProps) {
    const { t } = useTranslation();
    if (totalPages <= 1) {
        return null;
    }

    const from = pageIndex * pageSize + 1;
    const to = Math.min((pageIndex + 1) * pageSize, totalItems);

    return (
        <Group justify="apart" mt="xl" p="xs">
            <Text size="sm">
                {t(
                    "EMPLOYEEOVERVIEW_PAGINATION_SUMMARY",
                    { from: from.toString(), to: to.toString(), total: totalItems.toString() },
                    `Showing ${from}-${to} of ${totalItems} results`
                )}
            </Text>
            <Pagination
                total={totalPages}
                value={pageIndex + 1}
                onChange={onPageChange}
                size="sm"
                radius="md"
                withEdges
            />
        </Group>
    );
}
